"use client";
import dynamic from "next/dynamic.js";
import type { VoiceCloningV2Props } from "./VoiceCloningV2";

const VoiceCloningDemo = dynamic(() => import("./VoiceCloningV2").then(mod => mod.default));

export default function VoiceCloningV2Lazy(props: VoiceCloningV2Props) {
  return <VoiceCloningDemo {...props} />;
}
